import get from 'lodash/get';
import { IMAGE_DOMAIN_BASE_URL } from '../constants';

export const getCompanyImagePublicId = image => {
  if (image && image.public_id) {
    return image.public_id;
  }

  if (image && image.full && image.full.startsWith(IMAGE_DOMAIN_BASE_URL)) {
    return image.full.split('/').slice(-2).join('/');
  }

  return !!image && !!image.full && image.full.split('/').pop();
};

export const getCompanyImageIdsToSuspend = (values) => {
  const { image = {}, images = [], realtors = [] } = values;
  const ids = [];

  image && image.link && ids.push(image.link);
  images.forEach(({ link }) => link && ids.push(link));
  realtors.forEach(item => {
    const link = get(item, 'image.link');
    !!link && ids.push(link);
  });

  return ids;
};

export const mapCompanyImageForServer = (image) => ({
  _id: image._id,
  link: getCompanyImagePublicId(image),
  description: image.description,
  angle: image.angle || 0
});

